import { useQuery, useMutation, useQueryClient } from "react-query";
import { fetchProjects, createProject, updateProject, deleteProject, getProjectById } from "@/features/project/services/projectService";
const useProjects = (page = 1, filters = {}, all = false, limit = 10) => {
    const queryClient = useQueryClient();
    // Use the unified fetchProjects function to retrieve projects (paginated, filtered, or all).
    const { data, error, isLoading, refetch } = useQuery(["projects", { page, filters, all, limit }], () => fetchProjects(page, filters, all, limit), {
        keepPreviousData: true,
        staleTime: 60000, // Data is considered fresh for 60 seconds.
    });
    // Mutation for creating a new project.
    const addProjectMutation = useMutation((project) => createProject(project), {
        onSuccess: () => {
            queryClient.invalidateQueries(["projects"]);
        },
    });
    // Mutation for updating an existing project.
    const updateProjectMutation = useMutation(({ id, projectData }) => updateProject(id, projectData), {
        onSuccess: () => {
            queryClient.invalidateQueries(["projects"]);
        },
    });
    // Mutation for deleting a project.
    const deleteProjectMutation = useMutation((id) => deleteProject(id), {
        onSuccess: () => {
            queryClient.invalidateQueries(["projects"]);
        },
    });
    // Helper to fetch a single project by ID.
    const fetchSingleProject = async (id) => {
        return await getProjectById(id);
    };
    return {
        projects: data?.projects || [],
        meta: data?.meta || null,
        loading: isLoading,
        error: error ? error.message : null,
        refetchProjects: refetch,
        handleAddProject: addProjectMutation.mutateAsync,
        handleUpdateProject: (id, projectData) => updateProjectMutation.mutateAsync({ id, projectData }),
        handleDeleteProject: deleteProjectMutation.mutateAsync,
        fetchProject: fetchSingleProject,
    };
};
export default useProjects;
